import General from '../../utils/GeneralUtils';
import './TitleFragment.scss';

type ColorMode = 'value' | 'label' | 'grayscale';

const LABEL_COLOR_MAP: Record<string, number> = {
  modifier: 0, // blue
  role: 1, // green
  area: 3, // teal
  'decision level': 4, // orange
  'functional group': 7, // yellow
};

interface TitleFragmentProps {
  label: string;
  value: string;
  size?: 'normal' | 'small';
  colorMode?: ColorMode;
}

export function TitleFragment({ label, value, size = 'normal', colorMode = 'value' }: TitleFragmentProps) {
  const colorClass =
    colorMode === 'grayscale'
      ? 'title-fragment--grayscale'
      : `title-fragment--${colorMode === 'label' ? (LABEL_COLOR_MAP[label.toLowerCase()] ?? 0) : General.getCSSFromId(value)}`;
  const sizeClass = size === 'small' ? 'title-fragment--small' : '';

  return (
    <span className={`title-fragment ${colorClass} ${sizeClass}`}>
      <span className="title-fragment__label">{label}:</span>{' '}
      <span className="title-fragment__value">{value}</span>
    </span>
  );
}
